export default (sort, sortDirection, sortArray) => ({
    sort,
    sortDirection,
    sortArray,
    field: null,
    bulkCount: 0,
    multiple: false,
    sortingMode: 'single',

    init() {
        this.initialSort = this.sort;
    },

    handleClick(event, label) {
        if (this.multiple && event.shiftKey) {
            this.refreshSort(this.field);

            this.sort          = this.initialSort;
            this.sortDirection = 'asc';

            this.$wire.refreshTable();

            return;
        }

        this.handleSort(this.field, label, event.shiftKey || this.sortingMode === 'multiple');
    },

    sortBy(field, multiple = false, label=null) {
        this.field    = field;
        this.multiple = multiple;

        this.handleClick(this.$event, label);
    },

    handleSort(field, label, multiple) {
        if (!multiple) {
            this.refreshSort(field);

            this.sort = field;

            this.$wire.refreshTable();

            return;
        }

        this.sortingMode = 'multiple';

        const itemIndex = _.findIndex(this.sortArray, {field});

        if (Object.keys(this.sortArray).length === 0 || itemIndex === -1) {
            this.sortArray.push({ direction: 'asc', label, field });
        }

        if (itemIndex >= 0) {
            const prevDirection = this.sortArray[itemIndex].direction;

            if (prevDirection === 'asc') {
                this.sortArray[itemIndex].direction = 'desc';
            } else {
                this.sortArray.splice(itemIndex, 1);

                if (Object.keys(this.sortArray).length === 0) {
                    this.refreshSort(field);

                    this.sort          = this.initialSort;
                    this.sortDirection = 'asc';

                    this.$wire.refreshTable();

                    return;
                }
            }
        }

        var keys    = Object.keys(this.sortArray);
        var lastKey = keys[keys.length - 1];
        this.sort   = Object.keys(this.sortArray[lastKey])[0];

        this.$wire.refreshTable();
    },

    refreshSort(field) {
        const direction    = this.sortDirection === 'asc' ? 'desc' : 'asc';
        this.sortDirection = this.sort === field ? direction : 'asc';
        this.sortArray     = [];
        this.sortingMode   = 'single';
    },

    position(field) {
        const itemIndex = _.findIndex(this.sortArray, {field});

        if (itemIndex >= 0) {
            return this.sortArray[itemIndex].direction === 'asc' ?
                '<svg fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" width="16"><path stroke-linecap="round" stroke-linejoin="round" d="M4.5 15.75l7.5-7.5 7.5 7.5"></path></svg>' :
                '<svg fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" width="16"><path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5"></path></svg>';
        }

        return this.sort === field
            ? this.sortDirection === 'asc' ? '<svg fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" width="16"><path stroke-linecap="round" stroke-linejoin="round" d="M4.5 15.75l7.5-7.5 7.5 7.5"></path></svg>' :
                '<svg fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" width="16"><path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5"></path></svg>'
            : '<svg width="16" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" d="M8.25 15 12 18.75 15.75 15m-7.5-6L12 5.25 15.75 9"></path></svg>'
    },

    label(field) {
        return field.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
    }
})
